import styled from "styled-components";
import { FLEX } from "styles/flex";
import { InputLabel, ValidateWord } from "components/atoms/text/Text";
import * as mediaQuery from "components/MediaQuery";

interface ModalInputProps {
  label: string | React.ReactNode;
  essential?: boolean;
  placeholder?: string;
  children?: any;
  flex?: number;
  half?: boolean;
  noBold?: boolean;
  isValidated?: boolean;
  validatedWord?: string;
  isBubble?: boolean;
  bubbleContents?: any;
  hiddenLabel?: boolean;
}

export const Wrapper = styled.div<{ flex?: number; half?: boolean }>`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  width: ${({ half }) => (half ? "50%" : "100%")};
  padding: 10px 0;
  gap: 4px;
  flex: ${({ flex }) => flex && flex};
  color: ${({ theme }) => theme.COLORS.WHITE};
  ${mediaQuery.isMobile} {
    width: 100%;
  }

  .date-picker-wrapper {
    width: 100%;
  }

  .validate-word {
    padding-top: 0;
  }
  .date-picker-wrapper {
    width: 100%;
  }

  textarea {
    min-width: 100%;
    max-width: 100%;
    max-height: 150px;
  }
`;

export function ModalInput({
  label,
  essential,
  children,
  flex,
  half,
  noBold,
  isValidated,
  validatedWord,
  isBubble,
  bubbleContents,
  hiddenLabel,
}: ModalInputProps): JSX.Element {
  return (
    <Wrapper flex={flex} half={half} className="common-modal-input">
      {!hiddenLabel && (
        <InputLabel
          label={label}
          essential={essential}
          noBold={noBold}
          isBubble={isBubble}
          bubbleContents={bubbleContents}
        />
      )}
      {children}
      {isValidated && <ValidateWord data-testid="atoms-modal-input-validate">{validatedWord}</ValidateWord>}
    </Wrapper>
  );
}
